export default __webpack_public_path__ + "static/media/test15.0c83a321.jpg";